import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Radio, Input, Card, Badge, Alert } from 'antd'
import NumberFormat from 'react-number-format'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all, get } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

class ContaDashboard extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            cash_funds_pending: 0,
            cash_funds_trie_pending: 0
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        }

        /*if (localStorage.getItem('hotelConta'))
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.params.contaType === 'trie') 
            this.state = {...this.state, currentHotel: null};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        let query = {};

        if (this.props.app.user.type === 'gerente') {
            var hotelsId = _.pluck(this.props.app.user.hotels, 'objectId');
            query.objectId = {$in: hotelsId};
        }

        // Consulta los hoteles
        all('Hotel', {
            where: query,
            limit: 20
        }).then((resp) => {
            this.setState({
                hotels: resp.results
            });

            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});
        })
    }


    componentWillReceiveProps () {
        this.setBadges();
    }


    setBadges () {
        setTimeout(function() {

            // Query
            let queryCash = {status: 'requested'};

            if (this.props.params.contaType === 'hotel')
                queryCash.type = 'cash_funds'
            else
                queryCash.type = 'cash_funds_trie'

            if (this.state.currentHotel) 
                queryCash.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};

            // Obtiene la cantidad de movimientos pendientes
            all('Income', {
                where: queryCash,
                limit: 1,
                count: 1
            }).then((resp) => {
                this.setState({ cash_funds_pending: resp.count });
            })


            let queryOthers = {status: 'requested'};

            if (this.props.params.contaType === 'hotel')
                queryOthers.type = 'others'
            else
                queryOthers.type = 'others_trie'

            if (this.state.currentHotel) 
                queryOthers.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};

            // Obtiene la cantidad de movimientos pendientes (Pagos Luis)
            all('Income', {
                where: queryOthers,
                limit: 1,
                count: 1
            }).then((resp) => {
                this.setState({ cash_funds_trie_pending: resp.count });
            })
        }.bind(this), 1000);
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = {};
        query.name = {$regex: '(?i)' + value};

        if (this.props.app.user.type === 'gerente') {
            var hotelsId = _.pluck(this.props.app.user.hotels, 'objectId');
            query.objectId = {$in: hotelsId};
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel');
        } else {
            get('Hotel', value.key).then((resp) => {
                this.setState({currentHotel: resp});
                localStorage.setItem('hotelConta', JSON.stringify(resp));

                this.setBadges();
            });

            callback();
        }
    }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        
	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
                        Contabilidad {this.props.params.contaType === 'hotel' ? 'Hotel' : 'TRIE'}
                    </h1>
	            </section>

                {this.props.app.currentHotel.objectId || this.props.params.contaType === 'trie'
    	            ? <section className="content">
    	                <div className="box box-primary" style={{borderTopColor: this.props.params.contaType === 'hotel' && this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#88bf01'}}>
    	                    <div className="box-body">
    	                        <div className="row">
    	                            <div className="col-md-4 col-xs-12">
                                        <div className={this.props.params.contaType === 'hotel' ? 'bg-orange small-box' : 'bg-trie small-box'}>
                                            <div className="inner" style={{height: '100px'}}>
                                                <h3 className="color-white">Caja {this.props.params.contaType === 'hotel' ? 'Hotel' : 'TRIE'}</h3>
                                            </div>
                                            <div className="icon">
                                                <Icon name="chart-line" />
                                            </div>

                                            <Link className={this.props.params.contaType === 'hotel' ? 'bg-orange small-box-footer col-xs-6' : 'bg-trie small-box-footer col-xs-6'} to={this.props.params.contaType === 'hotel' ? '/incomes/cash_funds/cash_funds' : '/incomes/cash_funds/cash_funds_trie' } style={{opacity: 0.85}}>Movimientos <Icon name="arrow-right" /></Link>
                                            <Link className={this.props.params.contaType === 'hotel' ? 'bg-orange small-box-footer col-xs-6' : 'bg-trie small-box-footer col-xs-6'} to={this.props.params.contaType === 'hotel' ? '/incomes/cash_funds_requests/cash_funds' : '/incomes/cash_funds_requests/cash_funds_trie' } style={{opacity: 0.85}}>Solicitudes <span className="badge bg-danger">{this.state.cash_funds_pending}</span></Link>
                                        </div>
                                    </div>

                                    {this.props.params.contaType === 'hotel'
                                        ? <div className="col-md-4 col-xs-12">
                                            <div className={this.props.params.contaType === 'hotel' ? 'bg-purple small-box' : 'bg-trie small-box'}>
                                                <div className="inner" style={{height: '100px'}}>
                                                    <h3 className="color-white">Ventas</h3>
                                                </div>
                                                <div className="icon">
                                                    <Icon name="money-bill" />
                                                </div>
                                                <Link className="small-box-footer" to={this.props.params.contaType === 'hotel' ? '/incomes/payments/hotel' : '/incomes/payments/trie' }>Ver todos <Icon name="arrow-right" /></Link>
                                            </div>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-4 col-xs-12">
                                        <div className={this.props.params.contaType === 'hotel' ? 'bg-teal small-box' : 'bg-trie small-box'}>
                                            <div className="inner" style={{height: '100px'}}>
                                                <h3 className="color-white">Nóminas</h3>
                                            </div>
                                            <div className="icon">
                                                <Icon name="users" />
                                            </div>
                                            <Link className="small-box-footer" to={this.props.params.contaType === 'hotel' ? '/incomes/payroll/hotel' : '/incomes/payroll/trie'}>Ver todos <Icon name="arrow-right" /></Link>
                                        </div>
                                    </div>

                                    {this.props.app.user.type === 'administrador'
                                        ? <div> 
                                            <div className="col-md-4 col-xs-12">
                                                <div className={this.props.params.contaType === 'hotel' ? 'bg-green small-box' : 'bg-trie small-box'}>
                                                    <div className="inner" style={{height: '100px'}}>
                                                        <h3 className="color-white">Comisiones</h3>
                                                    </div>
                                                    <div className="icon">
                                                        <Icon name="user" />
                                                    </div>
                                                    <Link className="small-box-footer" to={this.props.params.contaType === 'hotel' ? '/incomes/commissions/hotel' : '/incomes/commissions/trie'}>Ver todos <Icon name="arrow-right" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                        : ''
                                    }

                                    {this.props.params.contaType === 'hotel'
                                        ? <div className="col-md-4 col-xs-12">
                                            <div className={this.props.params.contaType === 'hotel' ? 'bg-red small-box' : 'bg-trie small-box'}>
                                                <div className="inner" style={{height: '100px'}}>
                                                    <h3 className="color-white">Estado de <br />Resultados</h3>
                                                </div>
                                                <div className="icon">
                                                    <Icon name="file-invoice-dollar" />
                                                </div>
                                                <Link className="small-box-footer" to="/incomes/totals">Ver todos <Icon name="arrow-right" /></Link>
                                            </div>
                                        </div>
                                        : ''
                                    }
    	                        </div>
    	                    </div>
    	                </div>
    	            </section>
                    : <section className="content">
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-6 col-md-offset-3">
                                        <Alert
                                          message="Advertencia"
                                          description="Para utilizar el módulo contable deberá establecer un hotel en la opción de la parte de arriba <Cambiar Hotel>."
                                          type="warning"
                                          showIcon
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
	        </div>
	    )
	}
}

export default connect(({ContaDashboard, app}) => ({ContaDashboard, app}))(Form.create()(ContaDashboard))


// WEBPACK FOOTER //
// ./src/components/incomes/contaDashboard.js